import {
  USER_LOADING,
  USER_LOADED,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
} from "../types/authTypes";
import axios from "axios";

const extractErrorMessage = (err) => {
  // Try common backend patterns
  const data = err?.response?.data;
  if (!data) return "Network or server error";
  if (typeof data === "string") return data;
  if (data.error) return data.error;
  if (data.detail) return data.detail;
  if (data.message) return data.message;
  if (Array.isArray(data.available_roles) && data.available_roles.length) {
    return `Invalid role. Available roles: ${data.available_roles.join(", ")}`;
  }
  // Django/DRF style field errors: { email: ["..."], password: ["..."] }
  const firstKey = Object.keys(data)[0];
  if (firstKey) {
    const val = data[firstKey];
    if (Array.isArray(val)) return val[0];
    if (typeof val === "string") return val;
  }
  return "An error occurred";
};

export const loadUser = () => async (dispatch) => {
  dispatch({ type: USER_LOADING });
  const config = { headers: { "Content-Type": "application/json" } };
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}api/user/`, config);
    const user = res.data;
    dispatch({
      type: USER_LOADED,
      payload: { ...user, role: user.role },
    });
    return { ok: true, data: user };
  } catch (err) {
    return { ok: false, error: extractErrorMessage(err) };
  }
};

export const register = (data) => async (dispatch) => {
  const config = { headers: { "Content-Type": "application/json" } };
  try {
    // create user
    const registrationResponse = await axios.post(
      `${process.env.REACT_APP_API_URL}api/user/`,
      data,
      config
    );
    const userId = registrationResponse.data?.id;

    // bootstrap empty cart
    if (userId) {
      await axios.post(
        `${process.env.REACT_APP_API_URL}api/cart/`,
        { userId, quantity: 0 },
        config
      );
    }

    dispatch({
      type: REGISTER_SUCCESS,
      payload: { ...data, id: userId, role_id: data.role_id },
    });

    return { ok: true, id: userId };
  } catch (err) {
    const msg = extractErrorMessage(err);
    dispatch({ type: REGISTER_FAIL, msg });
    return { ok: false, error: msg };
  }
};

export const login = (email, password) => async (dispatch) => {
  const config = { headers: { "Content-Type": "application/json" } };
  const body = { email, password };
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}api/login/`, body, config);
    dispatch({ type: LOGIN_SUCCESS, payload: res.data });
    return { ok: true, data: res.data };
  } catch (err) {
    // Prefer server message; fallback to status-based
    let msg = extractErrorMessage(err);
    if (!msg && err.response?.status === 404) msg = "Email not registered";
    if (!msg && err.response?.status === 400) msg = "Invalid password";
    dispatch({ type: LOGIN_FAIL, msg: msg || "Login failed" });
    return { ok: false, error: msg || "Login failed" };
  }
};

export const logout = () => async (dispatch) => {
  dispatch({ type: LOGOUT_SUCCESS });
};
